import { useTranslation } from "react-i18next";
import { LOCATION_TYPES_WITH_ICONS } from "../../constants";
import { IconBox } from "../../../../common/components";
import { LocationType } from "../../types";

interface LocationTypesProps {
    selectedLocationType?: LocationType;
    onSelect: (key: LocationType) => void;
}

const LocationTypes = (props: LocationTypesProps) => {
    const { selectedLocationType, onSelect } = props;
    const { t } = useTranslation("setUpSpaces");

    const locationTypes = LOCATION_TYPES_WITH_ICONS.map((locationType) => ({
        ...locationType,
        value: t(`locationType.${locationType.key}`),
    }));

    return (
        <div className="flex flex-row gap-9">
            {locationTypes.map((locationTypeOption, index) => (
                <IconBox
                    src={locationTypeOption.src}
                    label={locationTypeOption.value}
                    isHighlighted={
                        selectedLocationType === locationTypeOption.key
                    }
                    onClick={() => onSelect(locationTypeOption.key)}
                    key={index}
                />
            ))}
        </div>
    );
};

export default LocationTypes;
